import { Envs } from '../../envs'

export class MakeInviteUrl {
  public execute(inviteId: string) {
    return `${Envs.APP_URL}/invites/${inviteId}/accept`
  }
}
